type AudienceType = 'all' | 'campaign' | 'role' | 'users' | 'segment';

type AudienceJson = {
  type?: AudienceType;
  campaign_id?: string;
  roles?: string[];
  user_ids?: string[];
  segments?: string[];
};

type MessageLike = {
  campaign_id?: string | null;
  audience_json?: AudienceJson | null;
};

type MessageVisibilityContext = {
  userId: string;
  memberRole: string;
  campaignIds: string[];
  segmentKeys: Set<string>;
};

const toStringArray = (value: unknown): string[] => {
  if (!Array.isArray(value)) return [];
  return value.filter((item): item is string => typeof item === 'string' && item.length > 0);
};

export const buildSegmentKeys = (
  customSegmentIds: string[],
  trainingModuleIds: string[],
) => {
  const keys = new Set<string>();

  customSegmentIds.forEach((segmentId) => {
    keys.add(`custom:${segmentId}`);
  });

  trainingModuleIds.forEach((moduleId) => {
    keys.add(`training:${moduleId}`);
  });

  return keys;
};

export const isMessageVisibleToPromoter = (
  message: MessageLike,
  context: MessageVisibilityContext,
) => {
  const audience = message.audience_json;
  if (!audience || typeof audience !== 'object') return false;

  const audienceType = audience.type;
  if (!audienceType) return false;

  if (audienceType === 'all') return true;

  if (audienceType === 'campaign') {
    const campaignId = message.campaign_id ?? audience.campaign_id;
    return !!campaignId && context.campaignIds.includes(campaignId);
  }

  if (audienceType === 'role') {
    return toStringArray(audience.roles).includes(context.memberRole);
  }

  if (audienceType === 'users') {
    return toStringArray(audience.user_ids).includes(context.userId);
  }

  if (audienceType === 'segment') {
    return toStringArray(audience.segments).some((segmentKey) =>
      context.segmentKeys.has(segmentKey),
    );
  }

  return false;
};
